module.exports = __webpack_public_path__ + "img/bins de madeira.a804309f.webp";